import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import ImageScroller from '../../components/imagescroller';
import HelpText from '../../components/gui/helpText';
import Input from '../../components/form/input';
import GuiList from '../../components/gui/list';
import UserProfileInline from '../../components/user/profileInline';
import Camera from '../../components/gui/camera';

import localUtil from '../../lib/util';
import { QRCodeSVG } from 'qrcode.react';


@withText(props => ({
    searchTitle: <Text id='input.search-for-user'>Search for user</Text>,
}))
class ConventionViewStageAdmin extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            loadingUser: {},
        };
    }

    newRound = async e => {
        const { loadAll = () => {} } = this.props;
        const { type } = e.target.closest('button').dataset;
        const { conventionStore } = this.props.stores;
        await conventionStore.newRound(type);
        await loadAll();
    }

    addNewParticipant = async e => {
        const { loadAll = () => {} } = this.props;
        const { id } = e.target.closest('button').dataset;
        const { conventionStore, userStore } = this.props.stores;
        const { searchUsersResult } = userStore;
        const user = searchUsersResult.find(user => user.id === parseInt(id, 10));
        await conventionStore.newParticipant(user);
        await loadAll();
    }

    editConvention = e => {
        const { id, title } = e.target.closest('button').dataset;
        const { drawerLevel = 1 } = this.props;
        const { loadAll = () => {} } = this.props;
		const { appState, conventionStore } = this.props.stores;
        conventionStore.deleteReloadTimer();
		const { drawerHeightLarge } = appState;
		appState.openDrawer('editConvention', {
            id,
			height: drawerHeightLarge,
            callback: () => {
                loadAll();
            },
		}, drawerLevel + 2);
	}

    getRubicCompetitionByNumber = async () => {
        this.setState({ loading: true });
        const { appState, conventionStore } = this.props.stores;
        const { convention } = conventionStore;
        const { nsfNumber } = convention;

        const response = await appState.rubicGetCompetitionByNumber(nsfNumber);
        const { data, status } = response;
        console.log('getRubicCompetitionByNumber', response);

        if (status === 200) {
            if (data && data.id) {
                // Update convention with Rubic data.
                const { id: nsfId } = data;
                await conventionStore.saveField(convention.id, 'nsfId', nsfId, true);
                appState.addToast({
                    type: 'success',
                    message: `Rubic competition found! ${nsfNumber}`
                }, 5000);
                console.log('getRubicCompetitionByNumber', 'Updated convention with Rubic data', { nsfId });
            } else {
                appState.addToast({
                    type: 'error',
                    message: `Rubic competition not found! ${nsfNumber}`,
                }, 5000)
                console.error('getRubicCompetitionByNumber', 'No data found for Rubic competition with number', nsfNumber);
                // appState.showToast('error', <Text id='convention.rubic-competition-not-found'>Rubic competition not found</Text>);
            }
        } else {
            appState.addToast({
                type: 'error',
                message: `Failed to fetch Rubic competition: ${response.status} ${response.statusText}`
            }, 5000);
        }
        this.setState({ loading: false });
    }

    // getRubicPersonSearch = async () => {
    //     const { appState } = this.props.stores;
    //     const response = await appState.rubicGetPersonSearch({ name: 'Per godkjenner hansen'});
    //     console.log('getRubicPersonSearch', response);
    // }

    lookupUser = async e => {
        const { id } = e.target.closest('button').dataset;
        const { loadingUser = {} } = this.state;
        loadingUser[id] = true;
        this.setState({ loadingUser });

        const { appState, conventionStore, userStore } = this.props.stores;
        const { convention } = conventionStore;
        const { participants } = convention;
        const participant = participants.find(p => p.id === parseInt(id, 10));
        if (participant) {
            console.log('lookupUser.participant', participant);
            const rubicQuery = {
                name: `${participant.firstname.trim()} ${participant.lastname.trim()}`,
            };
            if (participant.birth) {
                rubicQuery.birthDate = util.isoDate(participant.birth, false, false, true);
            }
            if (participant.cellphone) {
                rubicQuery.cellphone = participant.cellphone;
            }
            if (participant.email) {
                rubicQuery.email = participant.email;
            }
            console.log('lookupUser', 'Rubic query', rubicQuery);
            let response;
            if (participant.nsfId) {
                response = await appState.rubicGetPersonById(participant.nsfId);
            } else {
                response = await appState.rubicGetPersonSearch(rubicQuery);
            }

            console.log('lookupUser', 'Rubic response', response);

            if (response?.status !== 200) {
                console.error('lookupUser', 'Error looking up user in Rubic', response);
            }
            const { data } = response;
            let rubicPerson = null;
            // Test if response is an array or a single object.
            if (Array.isArray(data) && data.length === 1) {
                rubicPerson = data[0];
            } else if (data?.id) {
                // If we have a single result, we can use it directly.
                rubicPerson = data;
            } else {
                console.error('lookupUser', 'No user found in Rubic for query', rubicQuery);
                // alert('No participant found:' + ` ${participant.firstname} ${participant.lastname} - ${participant.cellphone} - ${participant.email}`);
                appState.addToast({
                    type: 'error',
                    message: `Rubic user not found! ${participant && ` ${participant.firstname} ${participant.lastname} - ${participant.cellphone} - ${participant.email}`}`
                }, 5000)
            }

            if (rubicPerson?.id) {
                const { id, firstName, lastName, email, mobile, birthDate, gender, rubicPersonId, memberships, disciplineClassifications, branchOrganizations } = rubicPerson;
                console.log('lookupUser.rubicPerson', { id, firstName, lastName, email, mobile, birthDate, gender, rubicPersonId, memberships, disciplineClassifications, branchOrganizations });
                const updateObject = {
                    nsfId: rubicPersonId,
                    rubicId: id,
                    nsfDiciplineClasses: disciplineClassifications,
                    nsfBranchOrganizations: branchOrganizations,
                };
                if (memberships && memberships.length > 0 && !participant.nsfClubId) {
                    const membership = memberships.find(m => m.isActiveAthlete);
                    console.log('lookupUser', 'Rubic membership', membership);
                    if (membership && membership.organizationId) {
                        const clubResponse = await appState.rubicGetClubById({ rubicOrganizationId: membership.organizationId });
                        console.log('lookupUser', 'Rubic club response', clubResponse);
                        if (clubResponse.status === 200) {
                            const club = clubResponse.data;
                            console.log('lookupUser', 'Found club from Rubic', club);
                            const { niF_OrganizationId, organizationName } = club;
                            updateObject.sportsClub = organizationName;
                            updateObject.nsfClubNumber = niF_OrganizationId;
                            updateObject.nsfClubId = membership.organizationId;
                        }
                    }
                }
                await userStore.adminUpdate(participant.id, updateObject);
                appState.addToast({
                    type: 'success',
                    message: `Rubic user found! ${rubicPersonId} - ${firstName} ${lastName} - ${updateObject.sportsClub}`,
                }, 5000)
            }

            const { loadAll = () => {} } = this.props;
            await loadAll();

            console.log('lookupUser.response', response);
        }

        delete loadingUser[id];
        this.setState({ loadingUser });
    }

    reportResultsToRubic = async () => {
        const { appState, conventionStore, conventionResultStore } = this.props.stores;
        const { convention } = conventionStore;
        const { id: conventionId } = convention;

        const norgesFeltTargetMaxValues = conventionResultStore.getNorgesfeltTargetMaxValues();

        this.setState({ reporting: true });
        const response = await appState.rubicReportResultsToNSF({ competitionId: conventionId, norgesfeltMax: norgesFeltTargetMaxValues });
        const { included = {} } = response;
        const { rubicReportHtml } = included;
        if (rubicReportHtml) {
            this.setState({ rubicReportHtml });
        }

        const { rubicResponse} = included;

        if (rubicResponse.status === 200) {
            appState.addToast({
                type: 'success',
                message: `Rubic results reported successfully! ${rubicResponse.status}: ${rubicResponse.data}`,
            }, 5000);
        } else {
            appState.addToast({
                type: 'error',
                message: `Error reporting results to Rubic! ${rubicResponse.status}: ${rubicResponse.data}`,
            }, 5000);
        }
        this.setState({ reporting: false });
    }

    searchInput = (e) => {
        const search = e.target.value;
        this.setState({ search });

        clearTimeout(this.searchTimer);
        if (search.length >= 3) {
            this.searchTimer = setTimeout(async () => {
                this.doSearch(search);
            }, 300);
        }
    }

    async doSearch(search) {
        const { userStore } = this.props.stores;
        if (search) {
            // console.log('doUpdateField.saveField', id, field, value);
            const result = await userStore.searchUsersAll({ search, showAll: 1 });
        } else {
            userStore.localUpdateField('searchUsersResult', []);
        }
    }

    clearSearch = () => {
        this.setState({ search: '' });
        this.doSearch('');
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.doSearch(this.state.search);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            this.clearSearch();
        }
    }

    render() {
        const {
            searchTitle,
        } = this.props;
        const {
            search,
            loading = false,
            loadingUser = {},
            rubicReportHtml,
        } = this.state;
        const { isInThePast, isConventionAdmin } = this.props;
        const { appState, userStore, conventionStore, conventionResultStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isCustomerAdmin, isTester, isVeterinary, language, searchUsersResult, customer } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { convention, disciplineMap = [], classMap = [] } = conventionStore;
        const { rubicOrganizationId } = customer;

        const isConventionIntegrated = rubicOrganizationId && convention.nsfNumber && convention.nsfId;
        const apiServer = util.getApiServer();
        const jwtToken = util.getJwtToken();

        return (<>
            <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mb-1 mt-3 text-danger'>
                <Text id='convention.admin'>Admin</Text>
            </div>
            <div class={`d-flex flex-column mt-0 mx-3 px-3 py-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} overflow-auto border border-danger shadow`}>
                {isInThePast ? <>
                    <div class='d-flex'>
                        <Text id='convention.in-the-past'>Convention is in the past and closed.</Text>
                    </div>
                </> : <>
                    <div class='d-flex font-weight-lighter border-bottom mb-2'>
                        <Text id='convention.add-new-round'>Add new round here:</Text>
                    </div>
                    <div class='d-flex flex-wrap justify-content-center'>
                        <button
                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                            onClick={this.newRound}
                            data-type='nais'
                        >
                            <i class='fa-duotone fa-plus' /> <Text id='convention.new-nais'>New NAIS</Text>
                        </button>
                        <button
                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                            onClick={this.newRound}
                            data-type='hurtig'
                        >
                            <i class='fa-duotone fa-plus' /> <Text id='convention.new-hurtig'>New hurtig</Text>
                        </button>
                        <button
                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                            onClick={this.newRound}
                            data-type='hurtig-half'
                        >
                            <i class='fa-duotone fa-plus' /> <Text id='convention.new-hurtig-half'>New hurtig-half</Text>
                        </button>
                        <button
                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                            onClick={this.newRound}
                            data-type='standard'
                        >
                            <i class='fa-duotone fa-plus' /> <Text id='convention.new-standard'>New standard</Text>
                        </button>
                        <button
                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                            onClick={this.newRound}
                            data-type='felt'
                        >
                            <i class='fa-duotone fa-plus' /> <Text id='convention.new-felt'>New felt</Text>
                        </button>
                        <button
                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                            onClick={this.newRound}
                            data-type='norgesfelt'
                        >
                            <i class='fa-duotone fa-plus' /> <Text id='convention.new-norgesfelt'>New norgesfelt</Text>
                        </button>
                        <button
                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                            onClick={this.newRound}
                            data-type='t-96'
                        >
                            <i class='fa-duotone fa-plus' /> <Text id='convention.new-t-96'>New T-96</Text>
                        </button>
                    </div>

                    <div class='d-flex mt-5 font-weight-lighter border-bottom mb-2'>
                        <Text id='convention.add-new-participant'>Add new participant:</Text>
                    </div>
                    <div class='d-flex flex-wrap justify-content-center'>
                        <div class='flex-fill input-group'>
                            <div class='input-group-prepend'>
                                <span class='input-group-text rounded-pill-left'>
                                    <i class='fa-regular fa-magnifying-glass'></i>
                                </span>
                            </div>
                            <input
                                class={`form-control ${!search ? 'rounded-pill-right' : ''}`}
                                type='text'
                                value={search}
                                placeholder={`${searchTitle}`}
                                onInput={this.searchInput}
                                onKeyDown={this.handleKeyDown}
                            />
                            {search && <div class='input-group-append'>
                                <button class='btn btn-danger rounded-pill-right' type='button' onClick={this.clearSearch}>
                                    <i class='fa-solid fa-circle-xmark'></i>
                                </button>
                            </div>}
                        </div>
                        {searchUsersResult && searchUsersResult.length ? <>
                            <div class='d-flex flex-wrap justify-content-center'>
                                {searchUsersResult.map(user => {
                                    return (<>
                                        <button
                                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                                            onClick={this.addNewParticipant}
                                            data-id={user.id}
                                        >
                                            <i class='fa-duotone fa-plus' /> {localUtil.displayName(user)} {user.cellphone}
                                        </button>
                                    </>);
                                })}
                            </div>
                        </> : <></>}
                    </div>
                </>}


                <div class='d-flex mt-5 font-weight-lighter border-bottom mb-2'>
                    <Text id='convention.convention-settings'>Convention settings:</Text>
                </div>
                <div class='d-flex flex-column justify-content-start'>
                    <div>
                        <span class='font-weight-lighter'><Text id='convention.convention-nsfid'>NSF ID</Text>:</span> {convention.nsfId ? <>
                            <i class='fa-duotone fa-check text-success' />
                        </> : <>
                            <i class='fa-duotone fa-xmark text-danger' />
                        </>} <span class='font-weight-lighter text-muted'>{convention.nsfId}</span>
                    </div>

                    <div><span class='font-weight-lighter'><Text id='convention.convention-nsfnumber'>NSF Number</Text>:</span> {convention.nsfNumber} </div>
                    <div><span class='font-weight-lighter'><Text id='convention.convention-integrated'>Is integrated with NSF</Text>:</span> {isConventionIntegrated ? <i class='fa-duotone fa-check text-success' /> : <i class='fa-duotone fa-xmark text-danger' />}</div>

                    {!convention.nsfNumber > 0 && <>
                        <button
                            class={`btn btn-sm btn-outline-primary rounded-pill mx-1 my-1`}
                            onClick={this.editConvention}
                            data-id={convention.id}
                            data-title={convention.title}
                        >
                            <i class='fa-duotone fa-pen-to-square' /> <Text id='convention.edit-convention'>Edit convention</Text>
                        </button>
                    </>}

                    {/* {!convention.nsfId && convention.nsfNumber && isAdmin && <> */}
                    {convention.nsfNumber > 0 && isAdmin && <>
                        <button
                            disabled={loading}
                            type='button'
                            class='btn btn-lg btn-outline-primary rounded-pill ml-2'
                            onClick={this.getRubicCompetitionByNumber}
                        >
                            <nobr>
                            {loading ? <i class='fa-duotone fa-spinner-third fa-spin mr-2' /> : <i class='fa-duotone fa-arrow-right mr-2' />}
                            <Text id='dyrejournal.rubic-competition-by-number-load'>Integrate with NSF by convention number</Text>
                            </nobr>
                        </button>
                    </>}

                </div>

                <div class='d-flex mt-5 font-weight-lighter border-bottom mb-2'>
                    <Text id='convention.all-participants'>All participants:</Text>
                </div>
                <div class='table-responsive'>
                    <table class='table table-sm table-striped table-hover'>
                        <thead>
                            <tr>
                                <th scope='col'>#</th>
                                <th scope='col'>&nbsp;</th>
                                <th scope='col'>&nbsp;</th>
                                <th scope='col'><nobr><Text id='convention.participant-name'>Name</Text></nobr></th>
                                <th scope='col'><nobr><Text id='convention.participant-club'>Club</Text></nobr></th>
                                <th scope='col'><nobr><Text id='convention.participant-nsfid'>NSF ID</Text></nobr></th>
                                <th scope='col'>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {convention.participants.map((participant, index) => {
                                return (
                                    <tr key={participant.id}>
                                        <td>{index + 1}</td>
                                        <td>{participant.rubicId ? <><i class='fa-duotone fa-check text-success' /></> : <><i class='fa-duotone fa-xmark text-danger' /></>}</td>
                                        <td>
                                            {isConventionIntegrated ? <>
                                                <button
                                                    disabled={loadingUser[participant.id]}
                                                    class={`btn btn-sm btn-outline-primary rounded-pill`}
                                                    onClick={this.lookupUser}
                                                    data-id={participant.id}
                                                >
                                                    {loadingUser[participant.id] ? <i class='fa-duotone fa-sync fa-spin' /> : <i class='fa-duotone fa-sync' />}
                                                </button>
                                            </> : <>
                                                <i class='fa-duotone fa-question text-warning' />
                                            </>}
                                        </td>
                                        <td>
                                            <nobr>{participant.firstname} {participant.lastname}</nobr>
                                        </td>
                                        <td><nobr>{participant.sportsClub}</nobr></td>
                                        <td>{participant.nsfId}</td>
                                        <td>
                                            <div class='d-flex flex-row overflow-hidden'>
                                                {participant?.nsfDiciplineClasses?.map((classItem) => {
                                                    const participantDisciplineName = disciplineMap.find((d) => d.id === classItem.disciplineId)?.name;
                                                    const participantClassName = classMap.find((c) => c.id === classItem.classId)?.name;
                                                    return (
                                                        <small key={classItem.id} class='badge badge-info ml-1 mt-1 font-weight-light rounded-pill'>
                                                            {participantDisciplineName}
                                                            {participantClassName ? ` - ${participantClassName}` : ''}
                                                            {/* {JSON.stringify(classItem)} */}
                                                        </small>
                                                    );
                                                })}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>


                <div class='d-flex mt-5 font-weight-lighter border-bottom mb-2'>
                    <Text id='convention.convention-results-reporting'>Convention results reporting:</Text>
                </div>
                <div class='d-flex flex-column justify-content-start'>
                    <a
                        href={`${apiServer}/api/conventions/norgesfelt/${convention.id}/download?jwtToken=${jwtToken}`}
                        target='_blank'
                        rel='noopener noreferrer'
                        class='btn btn-sm btn-outline-danger btn-block rounded-pill mr-2 mb-2'
                    >
                        <i class='fas fa-download mr-2' /><Text id='convention.results-download-norgesfelt-csv'>Download Norgesfelt CSV</Text>
                    </a>
                </div>
                <div class='d-flex flex-column justify-content-center align-items-center'>
                    {isConventionIntegrated ? <>
                        <button
                            class='btn btn-lg btn-danger btn-block rounded-pill mr-2 mb-2'
                            onClick={this.reportResultsToRubic}
                        >
                            <i class='fas fa-arrow-right mr-2' /><Text id='convention.results-report-nsf'>Report results to NSF</Text>
                        </button>
                    </> : <>
                        <Text id='convention.results-report-nsf-not-integrated'>Convention is not integrated with NSF, cannot report results.</Text>
                    </>}
                    {convention.rubicReported && <>
                        <div class='alert alert-success rounded-lg'>
                            <i class='fa-duotone fa-check mr-2' />
                            <Text id='convention.results-reported-nsf'>Results have been reported to NSF.</Text> {convention.rubicReportDate && <span class='text-muted'>({util.formatDate(convention.rubicReportDate, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })})</span>}
                        </div>
                    </>}
                </div>

                {rubicReportHtml && <>
                    <div class='d-flex mt-5 font-weight-lighter border-bottom mb-2'>
                        <Text id='convention.rubic-report'>Rubic report:</Text>
                    </div>
                    <div class='d-flex flex-column justify-content-start'>
                        <div class='p-3 rounded-lg shadow-sm' style={{ maxHeight: '500px', overflowY: 'auto' }}>
                            <iframe
                                srcDoc={rubicReportHtml}
                                style={{ width: '100%', height: '400px', border: 'none' }}
                                title='Rubic Report'
                            />
                        </div>
                    </div>
                </>}

            </div>
        </>);
    }
}
export default ConventionViewStageAdmin;
